export default "__VITE_ASSET__DUooxysG__"